import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getPlatformAnalytics(params) {
  const response = await axiosClient.get(`/admin/analytics${toQueryString(params)}`);
  return response.data;
}

export async function getStoreAnalytics(params) {
  const response = await axiosClient.get(`/store-analytics${toQueryString(params)}`);
  return response.data;
}

export async function getCityAnalytics({ cityId, ...params }) {
  const response = await axiosClient.get(`/admin/analytics/cities/${cityId}${toQueryString(params)}`);
  return response.data;
}

export async function getDistrictAnalytics({ districtName, ...params }) {
  const response = await axiosClient.get(
    `/admin/analytics/districts/${encodeURIComponent(districtName)}${toQueryString(params)}`
  );
  return response.data;
}
